import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { PagesComponent } from './pages.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ECommerceComponent } from './e-commerce/e-commerce.component';
import { NotFoundComponent } from './miscellaneous/not-found/not-found.component';
// import { ArticleComponent } from '../shared/article/article.component';
import { MediathequeComponent } from '../shared/mediatheque/mediatheque.component';
import { LoginComponent } from '../shared/login/login.component';
import { AuthGuard } from '../auth/auth-guard.service';

const routes: Routes = [{
 
  path: '',
  component: PagesComponent,
  children: [
    {
      path: 'cms',
      loadChildren: () => import('./cmspages/cmspages.module')
        .then(m => m.CmsPagesModule),
    },
    {
      path: 'ecole',
      loadChildren: () => import('./ecoles/ecole.module')
        .then(m => m.EcoleModule),
    },
    {
      path: 'formation',
      loadChildren: () => import('./formations/formations.module')
        .then(m => m.FormationsModule),
    },
    {
      path: 'key',
      loadChildren: () => import('./licencekey/licencekey.module')
        .then(m => m.LicenceKeyModule),
    },
    {
      path: 'offre',
      loadChildren: () => import('./offre/offre.module')
        .then(m => m.OffreModule),
    },
    {
      path: 'database',
      loadChildren: () => import('./database/database.module')
        .then(m => m.DatabaseModule),
    },
    {
      path: 'critere',
      loadChildren: () => import('./criteres/criteres.module')
        .then(m => m.CriteresModule),
    },
    {
      path: 'metier',
      loadChildren: () => import('./metiers/metiers.module')
        .then(m => m.MetiersModule),
    },
    {
      path: 'device',
      loadChildren: () => import('./device/device.module')
        .then(m => m.DeviceModule),
    },
    {
      path: 'job',
      loadChildren: () => import('./jobs/jobs.module')
        .then(m => m.JobsModule),
    },
    {
      path: 'utilisateurs',
      loadChildren: () => import('./users/users.module')
        .then(m => m.UsersModule),
    },
    {
      path: 'articles',
      loadChildren: () => import('./articles/articles.module')
        .then(m => m.ArticlesModule),
    },
    {
      path: 'category',
      loadChildren: () => import('./category/categories.module')
        .then(m => m.CategoriesModule),
    },
    {
      path: 'menus',
      loadChildren: () => import('./menu/menus.module')
        .then(m => m.MenusModule),
    },
    {
      path: 'setting',
      loadChildren: () => import('./settings/settings.module')
        .then(m => m.SettingsModule),
    },
    {
      path: 'projet',
      loadChildren: () => import('./projet/projets.module')
        .then(m => m.ProjetsModule),
    },
    {
      path: 'souscription',
      loadChildren: () => import('./souscription/souscriptions.module')
      .then(m => m.SouscriptionsModule),
    },
    {
      path: 'login',
      component: LoginComponent,
      
    },
    {
      path: 'mediatheque',
      component: MediathequeComponent,canActivate: [AuthGuard],
      
    },
    {
      path: 'messages',
      loadChildren: () => import('./messages/messages.module')
      .then(m => m.MessagesModule),
      
    },
    {
      path: 'dashboard',
      component: ECommerceComponent,canActivate: [AuthGuard],
    },
    {
      path: 'iot-dashboard',
      component: DashboardComponent,canActivate: [AuthGuard],
    },
    {
      path: 'layout',
      loadChildren: () => import('./layout/layout.module')
        .then(m => m.LayoutModule),
    },
    {
      path: 'forms',
      loadChildren: () => import('./forms/forms.module')
        .then(m => m.FormsModule),
    },
    {
      path: 'ui-features',
      loadChildren: () => import('./ui-features/ui-features.module')
        .then(m => m.UiFeaturesModule),
    },
    {
      path: 'modal-overlays',
      loadChildren: () => import('./modal-overlays/modal-overlays.module')
        .then(m => m.ModalOverlaysModule),
    },
    {
      path: 'extra-components',
      loadChildren: () => import('./extra-components/extra-components.module')
        .then(m => m.ExtraComponentsModule),
    },
    {
      path: 'maps',
      loadChildren: () => import('./maps/maps.module')
        .then(m => m.MapsModule),
    },
    {
      path: 'charts',
      loadChildren: () => import('./charts/charts.module')
        .then(m => m.ChartsModule),
    },
    {
      path: 'editors',
      loadChildren: () => import('./editors/editors.module')
        .then(m => m.EditorsModule),
    },
    {
      path: 'tables',
      loadChildren: () => import('./tables/tables.module')
        .then(m => m.TablesModule),
    },
    {
      path: 'miscellaneous',
      loadChildren: () => import('./miscellaneous/miscellaneous.module')
        .then(m => m.MiscellaneousModule),
    },
    {
      path: '',
      redirectTo: 'key/liste',
      pathMatch: 'full',
    },
    {
      path: '**',
      component: NotFoundComponent,
    },
  ],
},



];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {
}
